import React, { useEffect, useState } from "react";
import "./Dashboard.scss";
import { useNavigate } from "react-router-dom";
import type { FormProps, FormItemProps, Col, Row, Statistic } from "antd";
import {
  Button,
  Card,
  Avatar,
  Modal,
  Checkbox,
  Form,
  Input,
  Select,
  Space,
  message,
} from "antd";
import {
  UserAddOutlined,
  FileAddOutlined,
  LockOutlined,
} from "@ant-design/icons";
import { apiPost, apiGet } from "app/services/apiServices";
import {
  API_ENDPOINT_HELP_QUERY_SUBMIT,
  API_ENDPOINT_DASHBOARD_GIST_DATA,
} from "app/shared/MasterLayout/masterlayout.constant";
import PhoneIcon from "../../assets/images/PhoneOutlined.png";
import PhoneHoverIcon from "../../assets/images/Phone-icon-hover.png";
import ReusableModalForm from "app/shared/FormModal";
import { userInfo } from "app/config/States/users";
import { useRecoilState } from "recoil";
import AddPanModal from "../Dashboard/AddPanModal";
import InviteUserModal from "../Dashboard/InviteUser";
import InviteTMCModal from "../Dashboard/InviteTmc";

interface StatCardProps {
  icon: React.ReactNode;
  value: number;
  label: string;
  description: string;
}

const StatCard: React.FC<StatCardProps> = ({
  icon,
  label,
  value,
  description,
}) => {
  return (
    <Card className="stat-card">
      <div className="stat-inner">
        <div className={`stat-icon `}>{icon}</div>
        <div className="stat-content">
          <p className="stat-value">{value || 0}</p>
          <h3 className="stat-label">{label}</h3>
          <p className="stat-description">{description}</p>
        </div>
      </div>
    </Card>
  );
};

const RegistrationDashboard: React.FC = () => {
  const [form] = Form.useForm();
  const [isHovered, setIsHovered] = useState(false);
  const [open, setOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [modalText, setModalText] = useState("Content of the modal");
  const [userDetails, _] = useRecoilState<any>(userInfo);
  const navigate = useNavigate();

  console.log("User Details in Dashboard:", userDetails);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [query, setQuery] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [cardData, setCardData] = useState({
    total_users: { count: 0, last_month: 0 },
    total_admin_users: { count: 0, last_month: 0 },
    total_general_users: { count: 0, last_month: 0 },
    total_pans: { count: 0, last_month: 0 },
    total_travel_contact: { count: 0, last_month: 0 },
    total_tax_manager: { count: 0, last_month: 0 },
  });

  //invite forms
  const [isInviteUserModalVisible, setIsInviteUserModalVisible] =
    useState<boolean>(false);
  const [isAddPanModalVisible, setIsAddPanModalVisible] =
    useState<boolean>(false);
  const [isInviteTMCModalVisible, setIsInviteTMCModalVisible] =
    useState<boolean>(false);

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {
    setLoading(true);
    console.log("Fetching with URL:", API_ENDPOINT_DASHBOARD_GIST_DATA);
    const response = await apiGet(
      API_ENDPOINT_DASHBOARD_GIST_DATA +
        "?type=" +
        (userDetails.userInfo?.email?.includes("kgrp.in") ||
        userDetails.userInfo?.email?.includes("finkraft.ai")
          ? "ALL"
          : `SPECIFIC&user_id=${userDetails.userInfo?.id}`)
    );
    if (response.status && response.data) {
      setCardData({
        total_users: response.data.total_users,
        total_admin_users: response.data.total_admin_users,
        total_general_users: response.data.total_general_users,
        total_pans: response.data.total_pans,
        total_travel_contact: response.data.total_travel_contact,
        total_tax_manager: response.data.total_tax_manager,
      });
    }
    setLoading(false);
  };

  const showModal = () => {
    setOpen(true);
  };

  const handleOk = async () => {
    try {
      // Validate form fields
      const values = await form.validateFields();

      // Prepare payload
      const payload = {
        name: values.name,
        email: values.email,
        mobile: values.phone,
        query: values.query || "", // Make query optional
      };

      // Set loading state
      setConfirmLoading(true);

      // Make API call
      const response = await apiPost(API_ENDPOINT_HELP_QUERY_SUBMIT, payload);

      // Check API response
      if (response.status === true) {
        // Success scenario
        console.log("Callback request successful");
        message.success("Callback request submitted successfully");

        // Close modal and reset form
        setOpen(false);
        form.resetFields();
      } else {
        // Error scenario
        console.log("Callback request unsuccessful");
        message.error(response.message || "Failed to submit callback request");
      }
    } catch (errorInfo) {
      // Validation failed
      console.log("Validation Failed:", errorInfo);
      message.error("Please fill in all required fields");
    } finally {
      // Always reset loading state
      setConfirmLoading(false);
    }
  };

  const handleCancel = () => {
    console.log("Clicked cancel button");
    setOpen(false);
  };

  const handleViewInvoiceClick = () => {
    navigate("/app/invoices");
  };

  const handleInviteUserClick = () => {
    // setIsInviteUserModalVisible(true);
    navigate("/app/invite/user");
  };

  const handleAddPanClick = () => {
    // setIsAddPanModalVisible(true);
    navigate("/app/add/pan");
  };

  const handleInviteTmcClick = () => {
    // setIsInviteTMCModalVisible(true);
    navigate("/app/invite/tmc");
  };

  const stats = [
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
        >
          <circle cx="20" cy="20" r="20" fill="#74003B" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13 11C11.8954 11 11 11.8954 11 13V27C11 28.1046 11.8954 29 13 29H27C28.1046 29 29 28.1046 29 27V13C29 11.8954 28.1046 11 27 11H13ZM16 21C16 20.4477 15.5523 20 15 20C14.4477 20 14 20.4477 14 21V25C14 25.5523 14.4477 26 15 26C15.5523 26 16 25.5523 16 25V21ZM20 17C20.5523 17 21 17.4477 21 18V25C21 25.5523 20.5523 26 20 26C19.4477 26 19 25.5523 19 25V18C19 17.4477 19.4477 17 20 17ZM26 15C26 14.4477 25.5523 14 25 14C24.4477 14 24 14.4477 24 15V25C24 25.5523 24.4477 26 25 26C25.5523 26 26 25.5523 26 25V15Z"
            fill="white"
          />
        </svg>
      ),
      value: cardData.total_users.count,
      label: "Users",
      description: `${
        Number(cardData.total_users.count) !== 0
          ? cardData.total_users.last_month === cardData.total_users.count
            ? "+ 100% since last month"
            : `${cardData.total_users.last_month > 0 ? "+" : "-"}${(
                (cardData.total_users.last_month / cardData.total_users.count) *
                100
              ).toFixed(2)}% since last month`
          : "No data for last month"
      }\n\n\n`,
    },
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
        >
          <circle cx="20" cy="20" r="20" fill="#74003B" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12 14C12 11.7909 13.7909 10 16 10H22V14C22 16.2091 23.7909 18 26 18H28V26C28 28.2091 26.2091 30 24 30H16C13.7909 30 12 28.2091 12 26V14ZM16 19C15.4477 19 15 19.4477 15 20C15 20.5523 15.4477 21 16 21H18C18.5523 21 19 20.5523 19 20C19 19.4477 18.5523 19 18 19H16ZM16 23C15.4477 23 15 23.4477 15 24C15 24.5523 15.4477 25 16 25H20C20.5523 25 21 24.5523 21 24C21 23.4477 20.5523 23 20 23H16ZM24.6818 12.1988L24.5509 14.1629C24.5106 14.7666 25.0115 15.2674 25.6152 15.2272L27.5792 15.0962C28.4365 15.0391 28.8274 13.9989 28.2198 13.3913L26.3867 11.5582C25.7792 10.9507 24.7389 11.3415 24.6818 12.1988Z"
            fill="white"
          />
        </svg>
      ),
      value: cardData.total_pans.count,
      label: "PAN",
      description: `${
        Number(cardData.total_pans.count) !== 0
          ? cardData.total_pans.last_month === cardData.total_users.count
            ? "+ 100% since last month"
            : `${cardData.total_pans.last_month > 0 ? "+" : "-"}${(
                (cardData.total_pans.last_month / cardData.total_pans.count) *
                100
              ).toFixed(2)}% since last month`
          : "No data for last month"
      }\n\n\n`,
    },
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
        >
          <circle cx="20" cy="20" r="20" fill="#74003B" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M24.6261 13.2653L21.3263 13.7367C20.8222 13.8087 20.4103 14.049 20.1162 14.3811L12.4167 22.0806C11.6357 22.8616 11.6357 24.1279 12.4167 24.909L15.2452 27.7374C16.0263 28.5185 17.2925 28.5185 18.0736 27.7374L25.773 20.038C26.1051 19.7439 26.3454 19.332 26.4174 18.8279L26.8888 15.528C27.0775 14.2081 25.946 13.0767 24.6261 13.2653ZM22.3162 17.8379C22.7067 18.2284 23.3399 18.2285 23.7305 17.8379C24.121 17.4474 24.1209 16.8142 23.7305 16.4237C23.34 16.0332 22.7068 16.0332 22.3162 16.4237C21.9257 16.8142 21.9257 17.4474 22.3162 17.8379Z"
            fill="white"
          />
        </svg>
      ),
      value: cardData.total_travel_contact.count,
      label: "Travel Contacts",
      description: `${
        Number(cardData.total_travel_contact.count) !== 0
          ? cardData.total_travel_contact.last_month ===
            cardData.total_travel_contact.count
            ? "+ 100% since last month"
            : `${cardData.total_travel_contact.last_month > 0 ? "+" : "-"}${(
                (cardData.total_travel_contact.last_month /
                  cardData.total_travel_contact.count) *
                100
              ).toFixed(2)}% since last month`
          : "No data for last month"
      }\n\n\n`,
    },
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
        >
          <circle cx="20" cy="20" r="20" fill="#74003B" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M22 16C22 18.2091 20.2091 20 18 20C15.7909 20 14 18.2091 14 16C14 13.7909 15.7909 12 18 12C20.2091 12 22 13.7909 22 16ZM18 21C14.134 21 11 23.2386 11 26C11 27.1046 11.8954 28 13 28H23C24.1046 28 25 27.1046 25 26C25 23.2386 21.866 21 18 21ZM26 14C26.5523 14 27 14.4477 27 15V16H28C28.5523 16 29 16.4477 29 17C29 17.5523 28.5523 18 28 18H27V19C27 19.5523 26.5523 20 26 20C25.4477 20 25 19.5523 25 19V18H24C23.4477 18 23 17.5523 23 17C23 16.4477 23.4477 16 24 16H25V15C25 14.4477 25.4477 14 26 14Z"
            fill="white"
          />
        </svg>
      ),
      value: cardData.total_tax_manager.count,
      label: "Tax Managers",
      description: `${
        Number(cardData.total_tax_manager.count) !== 0
          ? cardData.total_tax_manager.last_month ===
            cardData.total_tax_manager.count
            ? "+ 100% since last month"
            : `${cardData.total_tax_manager.last_month > 0 ? "+" : "-"}${(
                (cardData.total_tax_manager.last_month /
                  cardData.total_tax_manager.count) *
                100
              ).toFixed(2)}% since last month`
          : "No data for last month"
      }\n\n\n`,
    },
  ];

  const InviteUserFormItems: FormItemProps<any>[] = [
    {
      label: "Name",
      name: "username",
      rules: [{ required: true, message: "Please input your name!" }],
      children: <Input />,
    },
    {
      label: "Email",
      name: "email",
      rules: [{ required: true, message: "Please input your email!" }],
      children: <Input />,
    },
    {
      label: "Mobile",
      name: "phone",
      rules: [{ required: true, message: "Please input your mobile!" }],
      children: <Input />,
    },
    {
      label: "LinkedIn profile link",
      name: "password",
      rules: [
        { required: true, message: "Please input your LinkedIn profile link!" },
      ],
      children: <Input />,
    },
  ];

  const InviteTMCFormItems: FormItemProps<any>[] = [
    {
      label: "Name",
      name: "username",
      rules: [{ required: true, message: "Please input your name!" }],
      children: <Input />,
    },
    {
      label: "Email",
      name: "email",
      rules: [{ required: true, message: "Please input your email!" }],
      children: <Input />,
    },
    {
      label: "Mobile",
      name: "phone",
      rules: [{ required: true, message: "Please input your mobile!" }],
      children: <Input />,
    },
    {
      label: "LinkedIn profile link",
      name: "password",
      rules: [
        { required: true, message: "Please input your LinkedIn profile link!" },
      ],
      children: <Input />,
    },
  ];

  const handleFinish = (values: any) => {
    console.log("Success:", values);
  };

  const handleFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  function getGreeting() {
    const now = new Date();
    const hour = now.getHours(); // Get the current hour (0-23)

    if (hour >= 5 && hour < 12) {
      return "Good Morning!";
    } else if (hour >= 12 && hour < 18) {
      return "Good Afternoon!";
    } else {
      return "Good Evening!";
    }
  }

  return (
    <div className="registration-container">
      {/* Action Buttons */}

      <div className="action-buttons">
        {!(
          userDetails?.userInfo?.email?.includes("finkraft.ai") ||
          userDetails?.userInfo?.email?.includes("kgrp.in")
        ) && (
          <>
            <button className="action-btn" onClick={handleInviteUserClick}>
              <UserAddOutlined />
              Add User
            </button>
            <button className="action-btn" onClick={handleAddPanClick}>
              <FileAddOutlined />
              Add PAN
            </button>
            <button className="action-btn" onClick={handleInviteTmcClick}>
              <UserAddOutlined />
              Add TMC
            </button>
            {/* 
            {isInviteUserModalVisible && (
              <InviteUserModal
                visible={isInviteUserModalVisible}
                onClose={() => setIsInviteUserModalVisible(false)}
              />
            )}
                <InviteUserModal
                  visible={isInviteUserModalVisible}
                  onClose={() => setIsInviteUserModalVisible(false)}
                />
            )} */}

            {isInviteTMCModalVisible && (
              <InviteTMCModal
                visible={isInviteTMCModalVisible}
                onClose={() => setIsInviteTMCModalVisible(false)}
              />
            )}
            {/* {isInviteTMCModalVisible && (
                <InviteTMCModal
                  visible={isInviteTMCModalVisible}
                  onClose={() => setIsInviteTMCModalVisible(false)}
                />
            )} */}

            {isAddPanModalVisible && (
              <AddPanModal
                visible={isAddPanModalVisible}
                onClose={() => setIsAddPanModalVisible(false)}
              />
            )}
            {/* {isAddPanModalVisible && (
                <AddPanModal
                  visible={isAddPanModalVisible}
                  onClose={() => setIsAddPanModalVisible(false)}
                />
            )} */}
          </>
        )}

        <button
          className="action-btn primary"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={showModal}
        >
          <img src={isHovered ? PhoneHoverIcon : PhoneIcon} alt="phone" />
          Request a call back
        </button>
      </div>

      <Modal
        title="Request a Callback"
        open={open}
        onOk={handleOk}
        onCancel={handleCancel}
        confirmLoading={confirmLoading}
        okText="Submit Request"
        okButtonProps={{
          style: {
            backgroundColor: "#74003B", // Vibrant green color
            borderColor: "#74003B",
          },
        }}
        cancelButtonProps={{
          style: { color: "#74003B", border: "1px solid #74003B" },
        }}
      >
        <Form form={form} layout="vertical" name="callback_request_form">
          <Form.Item
            name="name"
            label="Full Name"
            rules={[
              {
                required: true,
                message: "Please enter your full name",
              },
            ]}
          >
            <Input
              type="text"
              defaultValue=" "
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter your full name"
            />
          </Form.Item>

          <Form.Item
            name="email"
            label="Email"
            rules={[
              {
                required: true,
                message: "Please enter your email address",
              },
            ]}
          >
            <Input
              type="text"
              defaultValue=" "
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email address"
            />
          </Form.Item>

          <Form.Item
            name="phone"
            label="Phone Number"
            rules={[
              {
                required: true,
                message: "Please enter your phone number",
              },
              {
                pattern: /^[0-9]{10}$/,
                message: "Please enter a valid 10-digit phone number",
              },
            ]}
          >
            <Input
              type="text"
              defaultValue=" "
              value={mobile}
              onChange={(e) => setMobile(e.target.value)}
              placeholder="Enter 10-digit phone number"
              addonBefore="+91"
            />
          </Form.Item>

          <Form.Item name="query" label="Write your query here (Optional)">
            <Input.TextArea
              rows={3}
              defaultValue=" "
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Briefly describe your query or concern"
            />
          </Form.Item>
        </Form>
      </Modal>
      <div className="dashboard-container">
        {/* Instructions */}
        <div className="instructions">
          {getGreeting()}, {userDetails?.userInfo?.name}
        </div>

        {/* Status Cards */}
        <div className="invoice-request-header">
          <div
            className="stats-section"
            style={{
              display: "flex",
              justifyContent: "space-evenly",
              paddingBottom: "24px",
            }}
          >
            {stats.map((stat, index) => (
              <StatCard
                key={index}
                icon={stat.icon}
                value={stat.value}
                label={stat.label}
                description={stat.description}
                // color={stat.color}
              />
            ))}
          </div>
        </div>

        {/* View Invoices Button */}
        {/* <button className="view-invoices-btn" onClick={handleViewInvoiceClick}>
          View Invoices
        </button> */}

        {userDetails?.userInfo?.email !== "qatar.invoice@finkraft.ai" && (
          <button
            className="view-invoices-btn"
            onClick={handleViewInvoiceClick}
          >
            View Invoices
          </button>
        )}
      </div>
    </div>
  );
};

export default RegistrationDashboard;
